import { getValue } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';

/**
 * Custom page validation for pages for storm-bygning-landbrug
 * @param formValues
 * @param formConfig
 * @param pageId
 * @returns
 */
export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined,
    pageId: string | undefined
) => {
    if (!formValues || !formConfig) {
        return false;
    }

    switch (pageId) {
        case 'beboelsen-om-taget':
            return [
                getValue(formConfig, formValues, 'hvormangevingetagstenerdelagt2'),
                getValue(formConfig, formValues, 'hvormangedobbeltvingetagstenerdelagt2'),
                getValue(formConfig, formValues, 'hvormangerygningsstenerdelagt2'),
                getValue(formConfig, formValues, 'hvormangeenderygningsstenstartellerslutptagryggenerdelagt2')
            ].some((value) => value);
        case 'garage-teglsten':
            return [
                getValue(formConfig, formValues, 'hvormangevingetagstenerdelagtTeglstenTagGarage'),
                getValue(formConfig, formValues, 'hvormangedobbeltvingetagstenerdelagtTeglstenTagGarage'),
                getValue(formConfig, formValues, 'hvormangerygningsstenerdelagtTeglstenTagGarage'),
                getValue(formConfig, formValues, 'hvormangeenderygningsstenerdelagtTeglstenTagGarage')
            ].some((value) => value);
        case 'skur-om-taget':
            return [
                getValue(formConfig, formValues, 'hvormangevingetagstenerdelagtTeglstenTagSkur'),
                getValue(formConfig, formValues, 'hvormangedobbeltvingetagstenerdelagtTeglstenTagSkur'),
                getValue(formConfig, formValues, 'hvormangerygningsstenerdelagtTeglstenTagSkur'),
                getValue(formConfig, formValues, 'hvormangeenderygningsstenerdelagtTeglstenTagSkur')
            ].some((value) => value);
        case 'udestue-om-taget':
            return [
                getValue(formConfig, formValues, 'hvormangevingetagstenerdelagtTeglstenTagUdestuen'),
                getValue(formConfig, formValues, 'hvormangedobbeltvingetagstenerdelagtTeglstenTagUdestuen'),
                getValue(formConfig, formValues, 'hvormangerygningsstenerdelagtTeglstenTagUdestuen'),
                getValue(formConfig, formValues, 'hvormangeenderygningsstenerdelagtTeglstenTagUdestuen')
            ].some((value) => value);
        case 'anneks-om-taget':
            return [
                getValue(formConfig, formValues, 'hvormangevingetagstenerdelagtTeglstenTagAnneks1'),
                getValue(formConfig, formValues, 'hvormangedobbeltvingetagstenerdelagtTeglstenTagAnneks'),
                getValue(formConfig, formValues, 'hvormangerygningsstenerdelagtTeglstenTagAnneks'),
                getValue(formConfig, formValues, 'hvormangeenderygningsstenerdelagtTeglstenTagAnneks')
            ].some((value) => value);
        case 'drivhus-glasstoerrelse':
            return [
                getValue(formConfig, formValues, 'ca61Cmx6170Cmdrivhus'),
                getValue(formConfig, formValues, 'ca61Cmx210235Cmdrivhus')
            ].some((value) => value);
    }
    return true;
};
